/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmVectorStoresCancelFileBatch } from "../../funcs/llmVectorStoresCancelFileBatch.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CancelVectorStoreFileBatchRequest$inboundSchema,
};

export const tool$llmVectorStoresCancelFileBatch: ToolDefinition<typeof args> =
  {
    name: "llm-vector-stores-cancel-file-batch",
    description: `Cancel batch file processing

Cancels an in-progress file batch operation.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await llmVectorStoresCancelFileBatch(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
